import consumer from "./consumer"

/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

export let createNotificationConsumer = () => {
  const registrant_id = $('.webinar-container')[0].id;
  consumer.subscriptions.create({
    channel: 'MessageNotificationsChannel',
    id: registrant_id
  }, {
    connected() {},
    // Called when the subscription has been initiated
    disconnected() {},
    // Called when the subscription has been terminated by the server
    received(data) {
      const message = buildMessageHtml(data);
      $(`#message-response-${data['id']} .messages-list`).append(message);

      const button = $('button#show-chat');

      if (button.data().count === 0) {
        button.data().count += 1;
        return button.append(`<span class='badge badge-danger'>${button.data().count}</span>`);
      } else {
        button.data().count += 1;
        return $('button#show-chat .badge').html(button.data().count);
      }
    }
  });
};

let buildMessageHtml = data => (
  `<li class='message received'> \
     <div class='message-date'>${data['created_at']}</div> \
     <div class='message-box'>${data['content']}</div> \
     <div class='message-sender'>${data['sender']}</div> \
   </li>`
);
